import React from 'react';

const PermissionsSelect = (props) => (
    <select {...props}>
      <option/>
      {props.permissions.map((permission, key) => (
          <option value={permission.id} key={key}>
            {permission.name}
          </option>
      ))}
    </select>
);

export default PermissionsSelect;


// WEBPACK FOOTER //
// ./src/containers/RolePage/PermissionsSelect.js